import React from 'react';
import { MdAdd, MdDelete } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import PortalButton from './PortalButton';
import PortalFieldHelp from './PortalFieldHelp';

export default function FieldOptionsEditor({ options, onChange }) {
  const values = options?.length ? options : [''];
  return (
    <section className="portal-field-options" aria-label="Opções de resposta">
      <div className="portal-admin-row">
        <div>
          <h4>
            Opções de resposta
            <PortalFieldHelp label="Opções de resposta">
              Alternativas apresentadas ao candidato. Adicione cada opção em seu próprio campo; a
              ordem abaixo será preservada na inscrição.
            </PortalFieldHelp>
          </h4>
          <p>Configure as alternativas que o candidato poderá escolher.</p>
        </div>
        <DefaultButton
          text="Adicionar opção"
          bg="confirm"
          icon={<MdAdd />}
          onClick={() => onChange([...values, ''])}
        />
      </div>
      {values.map((value, index) => (
        <div className="portal-option-row" key={index}>
          <span className="portal-option-number" aria-hidden="true">
            {index + 1}
          </span>
          <label className="form-label">
            <span className="visually-hidden">Opção {index + 1}</span>
            <input
              className="form-control"
              required
              maxLength={255}
              value={value}
              placeholder={`Digite a opção ${index + 1}`}
              onChange={(event) =>
                onChange(
                  values.map((option, position) =>
                    position === index ? event.target.value : option
                  )
                )
              }
            />
          </label>
          <PortalButton
            title={`Remover opção ${index + 1}`}
            className="btn btn-sm btn-danger"
            disabled={values.length === 1}
            onClick={() => onChange(values.filter((_, position) => position !== index))}
          >
            <MdDelete />
          </PortalButton>
        </div>
      ))}
    </section>
  );
}
